// AB test: no_tip_jar_on_amount_page
// Can be removed when experiment has ended
import { DonationAmountContext } from '../context/DonationAmountContext';

import { useNotNullableContext } from './useNotNullableContext';

export const useDonationAmount = () =>
  useNotNullableContext(DonationAmountContext);
